import { useEffect, useState, useContext } from 'react';
import { useForm } from "react-hook-form";
import { Modal, Button } from 'react-bootstrap';
import * as Api from '../../api/Api';
import { useQuery } from 'react-query';
import * as KeyNames from '../../api/KeyNames';
import { ErrorConnection } from '../../Components/Error/Error';
import { Loading } from '../../Components/Loading/Loading';
import { FeedbackContext } from "../../Components/Context/FeedbackContext";
import * as PathNames from '../../api/PathNames';
import { generateToken } from '../../Components/Utils/Utils';
import { useGetToken } from '../../Hooks/CustomHooks';
import PermissionsGate from '../../../app/api/PermissionsGate';
import { SCOPES } from '../../../app/config/permissions-map';
import { SessionContext } from '../../Components/Context/SessionContext';

export default function AddUser({ showAddUser, setShowAddUser, setRefreshData }) {
    const { feedbackContext, setFeedbackContext } = useContext(FeedbackContext);
    const { session } = useContext(SessionContext);
    let resetToken;
    const [newUser, setNewUser] = useState(null);
    const { register, handleSubmit, formState: { errors }, reset } = useForm();

    const onSubmit = dataNewUser => {
        resetToken = generateToken();
        setNewUser({
            ...dataNewUser,
            resetToken: resetToken,
            url: PathNames.RouteActivateAccount + '?a=' + resetToken,
        });
    };
    const token = useGetToken();
    //Llamada al servicio de ADDUSER. El key debe ser único y por eso se setea con el resetToken
    let { data, isLoading, isError, error } = useQuery([KeyNames.SessionRespuesta, newUser ? newUser.resetToken : ""],
        async () => await Api.addUser(
            { newUser, token }
        ),
        {
            enabled: Boolean(newUser)
        });

    useEffect(() => {
        if (data) {
            if (data.success) {
                setFeedbackContext({ ...feedbackContext, showMessage: true, idMessage: 100 });
                reset(null);
                setNewUser(null);
                setRefreshData(true);
                setShowAddUser(false);
            } else {
                setFeedbackContext({ ...feedbackContext, showError: true, idError: data.errorId });
            }
        }

    }, [data]);


    if (isLoading) return (<Loading />)
    if (isError) return (<ErrorConnection error={error/*.response.status*/} />)

    return (
        <PermissionsGate RenderError={() => <></>} scopes={[SCOPES.GESTION_USUARIOS]} >
            <Modal show={showAddUser} onHide={() => setShowAddUser(false)} animation={false} aria-labelledby="contained-modal-title-vcenter"
                centered>
                <Modal.Header >
                    <Modal.Title>Agregar usuario</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form>

                        <div className="fv-row mb-7 ">
                            <label className="required fw-bold fs-6 mb-2">Correo Electrónico</label>
                            <input type="email" {...register("email", { required: true })} className="form-control form-control-solid mb-3 mb-lg-0" placeholder="Correo Electrónico" />
                            <>{errors.email && <span className="text-danger">Ingresar el correo</span>}</>
                        </div>

                        <div className="fv-row mb-7 ">
                            <label className="required fw-bold fs-6 mb-2">Nombre Completo</label>
                            <input type="text" {...register("name", { required: true })} className="form-control form-control-solid mb-3 mb-lg-0" placeholder="Nombre Completo" />
                            <>{errors.name && <span className="text-danger">Ingresar el nombre</span>}</>
                        </div>

                        <div className="fv-row mb-7 ">
                            <label className="fw-bold fs-6 mb-2">DNI</label>
                            <input type="text" {...register("dni", { required: false })} className="form-control form-control-solid mb-3 mb-lg-0" placeholder="DNI" />
                            <>{errors.name && <span className="text-danger">Ingresar el DNI</span>}</>
                        </div>
                        <div className="fv-row mb-7">
                            <label className="required fw-bold fs-6 mb-2">Rol</label>
                            <select className="form-select form-select-solid" {...register("role", { required: true })}>
                                <option value="">Selecciona</option>
                                {
                                    session.roleList.map(role => <option key={role.id} value={role.id}> {role.name}</option>)
                                }
                            </select>
                            <>{errors.role && <span className="text-danger">Selecciona un rol</span>}</>
                        </div>

                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secundary" onClick={() => setShowAddUser(false)}>Descartar</Button>
                    <Button variant="primary" onClick={handleSubmit(onSubmit)}>Guardar</Button>
                </Modal.Footer>
            </Modal>
        </PermissionsGate>
    )
}
